export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";
export const CLEAR_DATA_REQUEST = "CLEAR_DATA_REQUEST";
export const SET_SELECTED_GPT_MODAL = "SET_SELECTED_GPT_MODAL";
export const SET_SELECTED_AGENT = "SET_SELECTED_AGENT";
export const SET_RBAC_DATA = "SET_RBAC_DATA";
export const SET_THINKING_ENABLED = "SET_THINKING_ENABLED";
export const SET_WEB_SEARCH_ENABLED = "SET_WEB_SEARCH_ENABLED";
export const SET_FILE_UPLOADED = "SET_FILE_UPLOADED";
export const SET_NPS_POPUP_VISIBILITY = "SET_NPS_POPUP_VISIBILITY";
export const SET_SIDEBAR_COLLAPSED = "SET_SIDEBAR_COLLAPSED";
export const SET_SELECTED_THREAD_NAME = "SET_SELECTED_THREAD_NAME";
export const SET_CATEGORY_PROMPTS = "SET_CATEGORY_PROMPTS";
export const SET_SELECTED_TOOL = "SET_SELECTED_TOOL";
export const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";
export const SET_TALENT_PULSE_WEB_SEARCH_ENABLED = "SET_TALENT_PULSE_WEB_SEARCH_ENABLED";
